export enum BannerEnum {
  POSTER = 'POSTER',
  BOOK = 'BOOK',
}
